import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
declare const initComposerEmbedManager: any;

@Component({
  selector: 'app-add-analytics-builder',
  templateUrl: './add-analytics-builder.component.html',
  styleUrls: ['./add-analytics-builder.component.scss']
})
export class AddAnalyticsBuilderComponent implements OnInit,OnDestroy {

  @Input() public Content: any;

  constructor(public modalRef: NgbActiveModal) { }

  ngOnInit(): void {
    this.LoadDashboard();
  }
  ngOnDestroy(): void {
    const elements = document.getElementsByClassName("embedDash_new")[0];
    elements.innerHTML = "";
    $("#embedDash_new").empty();
  }
  
  LoadDashboard(dashboardId?: string) {

    const elements = document.getElementsByClassName("embedDash_new")[0];
    elements.innerHTML = "";
    $("#embedDash_new").empty();

    const getEmbedManagerPromise =
      initComposerEmbedManager({
        initialToken: this.Content.user_Org_Accesstoken
      });

    getEmbedManagerPromise.then((embedManager: any) => {
      embedManager.createComponent('dashboard',
        {
          //dashboardId: this.embedDashboardID,
          "theme": "modern",
          "editor": { "placement": "dockRight" },
          "header": {
            "showTitle": true,
          }
        }
      ).then((dashboard: any) => dashboard.render(
        document.getElementById("embedDash_new"),
        { width: '100%', height: '100%' }
      ))
    });
  }

  closePopup() {
    this.modalRef.close();
  }
}
